<template>
    <v-form
        class="signup-form text-center px-5 pb-5"
        method="POST"
        :action="facebookRegistrationRoute"
    >
    <input type="hidden" name="_token" :value="csrf" />

    <v-btn
        class="white--text"
        color="#1A77F2"
        id="register"
        name="registerToFb"
        type="submit"
        x-large
        depressed
    >
        <img
        id="icon-fb"
        :src="whiteFacebookLogo"
        alt="facebook-logo"
        />Continue with Facebook</v-btn
    >
    </v-form>
</template>
<script>
export default {
    name: "ContinueWithFacebook",
    props: {
        csrf: String,
        "facebook-registration-route": String,
        "white-facebook-logo": String,
    },
};
</script>
<style scoped>
/*  content padding/margins need to be removed
    for mobile styling not to have a border
*/

#icon-fb {
  width: 2rem;
  margin-right: 8px;
  margin-bottom: 2px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

/*Vuetify*/

.v-btn {
  width: 90%;
}
</style>
